import React from 'react';

export enum MenuItemType {
  divider = 'divider',
  heading = 'heading',
  headingAndDivider = 'headingAndDivider',
  item = 'item',
}

export type BaseMenuItem = {
  type: MenuItemType;
  label?: string;
  icon?: React.ReactNode;
  shouldOpenInNewWindow?: boolean;
  count?: number;
  href?: string;
  isBold?: boolean;
};
export type MenuItemWithSubMenu<T> = BaseMenuItem & {
  subMenu?: Array<T>;
};
export type MenuData = {
  label: string;
  href?: string;
  menuItems: Array<MenuItemWithSubMenu<MenuItemWithSubMenu<BaseMenuItem>>>;
};
